import React from 'react';
import { Card, CardContent } from '../ui/card';
import { 
  FileText, 
  Search, 
  AlertTriangle, 
  BarChart3, 
  Target, 
  MessageCircle 
} from 'lucide-react';

const painPoints = [
  {
    icon: FileText,
    quote: "I can only remember the last 2 weeks for reviews",
    impact: "Recency bias",
    color: "text-amber-400"
  },
  {
    icon: Search,
    quote: "I don't know what my team is actually struggling with",
    impact: "Blind spots",
    color: "text-blue-400"
  },
  {
    icon: AlertTriangle,
    quote: "Problems surface in 1:1s too late",
    impact: "Reactive management",
    color: "text-red-400"
  },
  {
    icon: BarChart3,
    quote: "HR wants skills data I don't have",
    impact: "No evidence",
    color: "text-purple-400"
  },
  {
    icon: Target,
    quote: "Who's ready for promotion? I'm guessing",
    impact: "No visibility",
    color: "text-green-400"
  },
  {
    icon: MessageCircle,
    quote: "I'm writing the same review twice",
    impact: "Wasted time",
    color: "text-indigo-400"
  }
];

const TeamsPainPoints = () => {
  return (
    <section 
      id="pain-points"
      className="py-24 bg-slate-950"
      data-testid="teams-pain-points"
    >
      <div className="max-w-6xl mx-auto px-6">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Sound familiar?
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            Every manager faces these challenges. Most just accept them as part of the job.
          </p>
        </div>

        {/* Pain point cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {painPoints.map((point, index) => (
            <Card 
              key={index}
              className="bg-slate-900/50 border-slate-800 hover:border-slate-700 transition-all duration-300 hover:-translate-y-1"
              data-testid={`pain-point-${index}`}
            >
              <CardContent className="p-6">
                <point.icon className={`w-8 h-8 ${point.color} mb-4`} />
                <p className="text-white font-medium text-lg mb-3 leading-snug">
                  "{point.quote}"
                </p>
                <div className="flex items-center gap-2">
                  <span className="text-slate-500">→</span>
                  <span className={`${point.color} font-medium text-sm`}>
                    {point.impact}
                  </span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamsPainPoints;
